import { Heading } from "@chakra-ui/react";

export const NoData = () => {
  return <Heading>Sorry, no data found</Heading>;
};
